import { RootActions, RootState } from "common/reducers";
import { Map, Record } from "immutable";
import { receive } from "common/reducers/Utils";
import { SlideRecord, slideFromJSON } from "common/records/Slide";
import { SlideActions, RECEIVE_SLIDE, RECEIVE_SLIDES } from "common/reducers/slide.actions";

export const SlideStateRecord = Record({
  byId: Map<number, SlideRecord>(),
  lastSavedById: Map<number, SlideRecord>(),
});

export const initialState = SlideStateRecord();
export type SlideState = typeof initialState;
export const model = "slides";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_SLIDE:
      return receive(state, model, slideFromJSON(action.payload.slide)) as RootState;

    case RECEIVE_SLIDES:
      action.payload.slides.forEach((s) => {
        state = reducer(state, SlideActions.receiveSlide(s));
      });

      return state;

    default:
      return state;
  }
};
